export const TEXT_SEGMENT_FONT_OPTIONS = [
    { value: null, label: "Predeterminada" },
    { value: "Inter", label: "Inter" },
    { value: "Space Grotesk", label: "Space Grotesk" },
    { value: "Poppins", label: "Poppins" },
    { value: "Playfair Display", label: "Playfair Display" },
    { value: "Lora", label: "Lora" },
    { value: "Caveat", label: "Caveat" }
];
